// extracted by mini-css-extract-plugin
module.exports = {"icon":"OrgsFilterToggle_icon__1YcUT"};